import { useTagManager } from '@demv_systems/feu-tag-manager';

export function useTrackSearch(category: string, isCompany: boolean | null) {
  function trackSearch() {
    useTagManager().push({
      event: category,
      isCompany: isCompany !== null ? isCompany : false,
    });
  }

  return { trackSearch }
}
